import { GeneralInfoType } from './GeneralInfo.types';

export function fetchGeneralInfo(data: GeneralInfoType): Promise<GeneralInfoType> {
  return new Promise<GeneralInfoType>((resolve) => {
    resolve(data);
  });
}
